import { useState, ChangeEventHandler, RefObject } from "react";
import { RefCallBack } from "react-hook-form";
import { TextInput } from "./TextInput";
import { PasswordConstraints } from "../../../core/api/administrators/types";
import Icon from "../Icon";
import PasswordStrengthIndicator from "../PasswordStrengthIndicator/PasswordStrengthIndicator";
import PasswordHintsTooltip from "./PasswordHintsTooltip";

export interface PasswordInputProps {
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  description?: string;
  validationError?: string;
  value?: string;
  inputRef?: RefObject<HTMLInputElement> | RefCallBack;
  withIndicator?: boolean;
  invalid?: boolean;
  withHint?: boolean;
  autoComplete?: string;
  disableBrowserAutocomplete?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  passwordConstraints?: PasswordConstraints;
  dataCy?: string;
}

export const PasswordInput = ({
  id,
  autoComplete = "on",
  disableBrowserAutocomplete,
  label = "",
  placeholder = "",
  required = false,
  disabled = false,
  description = "",
  validationError = undefined,
  value = "",
  inputRef,
  withIndicator,
  invalid,
  withHint,
  passwordConstraints,
  dataCy,
  onChange = () => {},
}: PasswordInputProps) => {
  const [type, setType] = useState<"password" | "text">("password");

  return (
    <div className="w-100">
      <TextInput
        id={id}
        dataCy={dataCy}
        dataCyBtn="password_button"
        dataPrAt="left-25 center"
        autoComplete={autoComplete}
        disableBrowserAutocomplete={disableBrowserAutocomplete}
        inputRef={inputRef}
        type={type}
        label={label}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        description={description}
        validationError={validationError}
        invalid={invalid}
        value={value}
        onChange={onChange}
        iconLabel={type === "password" ? "show password" : "hide password"}
        renderIcon={() =>
          type === "password" ? (
            <Icon dataCy="show_password_icon" name="eye" size={24} />
          ) : (
            <Icon dataCy="hide_password_icon" name="eye-off" size={24} />
          )
        }
        iconPosition="right"
        onIconClick={
          disabled
            ? undefined
            : () => {
                type === "password" ? setType("text") : setType("password");
              }
        }
      />
      {withIndicator && passwordConstraints && (
        <PasswordStrengthIndicator value={value} />
      )}
      {withHint && passwordConstraints && (
        <PasswordHintsTooltip
          inputId={id}
          value={value}
          passwordConstraints={passwordConstraints}
        />
      )}
    </div>
  );
};
export default PasswordInput;
